<template>
  <v-container fluid background>
    <v-layout align-center justify-center>
      <v-flex xs12 px-2>
        <v-layout row wrap text-xs-center my-1>
          <v-flex md6 sm6 xs6>
            <v-layout row wrap>
              <v-flex xs12 text-xs-left class="white--text">
                <span>
                  <v-icon
                    fab
                    dark
                    style="font-size: 2em; margin-top: 15px"
                    @click="autoplayvideo(0)"
                    >info</v-icon
                  >{{ $t("Video_Manual") }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex md6 sm6 xs6>
            <v-layout row wrap>
              <v-flex xs12 text-xs-right class="white--text">
                <span>
                  <strong style="font-size: 1.1em"
                    >&nbsp;{{ dateformat(date_picker_model.date) }}</strong
                  >
                </span>
                <br />
                <span>
                  <strong style="font-size: 0.9em; width: 250px; margin-left: 5px">{{
                    currentTime
                  }}</strong>
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout align-center justify-center contain>
      <v-flex lg12 md12 sm12 xs12 text-xs-center>
        <v-layout row wrap>
          <v-flex xl2 lg3 md4 sm4 xs6 @click="goto('/ImportFile/ListIncome')">
            <v-card class="box-dash box-pointerdash box-success">
              <v-icon
                fab
                dark
                class="icon-menudash"
                color="success"
                style="margin-bottom: 5px"
                >fas fa-folder-plus</v-icon
              >
              <br />
              <span
                ><strong class="font-menudash">{{
                  $t("menu.ImportFileIncome")
                }}</strong></span
              >
            </v-card>
          </v-flex>
          <v-flex xl2 lg3 md4 sm4 xs6 @click="goto('/ImportFile/ListExpensed')">
            <v-card class="box-dash box-pointerdash box-error">
              <v-icon
                fab
                dark
                color="error"
                class="icon-menudash"
                style="margin-bottom: 5px"
                >fas fa-folder-minus</v-icon
              >
              <br />
              <span
                ><strong class="font-menudash">{{
                  $t("menu.ImportFileExpensed")
                }}</strong></span
              >
            </v-card>
          </v-flex>
          <v-flex xl2 lg3 md4 sm4 xs6 @click="goto('/salarytable/list')">
            <v-card class="box-dash box-pointerdash box-info">
              <v-icon
                fab
                dark
                class="icon-menudash"
                color="info"
                style="margin-bottom: 5px"
                >fas fa-calculator</v-icon
              >
              <br />
              <span
                ><strong class="font-menudash">{{
                  $t("menu.SalaryTableList")
                }}</strong></span
              >
            </v-card>
          </v-flex>
          <v-flex xl2 lg3 md4 sm4 xs6 @click="goto('/income/list')">
            <v-card class="box-dash box-pointerdash box-info">
              <v-icon
                fab
                dark
                color="info"
                class="icon-menudash"
                style="margin-bottom: 5px"
                >fas fa-file-invoice-dollar</v-icon
              >
              <br />
              <span
                ><strong class="font-menudash">{{ $t("menu.IncomeList") }}</strong></span
              >
            </v-card>
          </v-flex>
          <v-flex xl2 lg3 md4 sm4 xs6 @click="goto('/expensed/list')">
            <v-card class="box-dash box-pointerdash box-error">
              <v-icon
                fab
                dark
                color="error"
                class="icon-menudash"
                style="margin-bottom: 5px"
                >fas fa-file-invoice-dollar</v-icon
              >
              <br />
              <span
                ><strong class="font-menudash">{{
                  $t("menu.ExpensedList")
                }}</strong></span
              >
            </v-card>
          </v-flex>

          <v-flex xl2 lg3 md4 sm4 xs6 @click="goto('/resign/list')">
            <v-card class="box-dash box-pointerdash box-grey">
              <v-icon
                fab
                dark
                color="grey"
                class="icon-menudash"
                style="margin-bottom: 5px"
                >fas fa-user-times</v-icon
              >
              <br />
              <span
                ><strong class="font-menudash">{{ $t("menu.ReSignList") }}</strong></span
              >
            </v-card>
          </v-flex>
          <v-flex xl2 lg3 md4 sm4 xs6 @click="goto('/changesalary/list')">
            <v-card class="box-dash box-pointerdash box-success">
              <v-icon
                fab
                dark
                color="success"
                class="icon-menudash"
                style="margin-bottom: 5px"
                >fas fa-file-signature</v-icon
              >
              <br />
              <span
                ><strong class="font-menudash">{{
                  $t("menu.ChangeSalaryList")
                }}</strong></span
              >
            </v-card>
          </v-flex>
          <v-flex xl2 lg3 md4 sm4 xs6 @click="goto('/branch/list')">
            <v-card class="box-dash box-pointerdash box-info">
              <v-icon
                fab
                dark
                color="info"
                class="icon-menudash"
                style="margin-bottom: 5px"
                >fas fa-building</v-icon
              >
              <br />
              <span
                ><strong class="font-menudash">{{ $t("menu.BranchList") }}</strong></span
              >
            </v-card>
          </v-flex>
          <v-flex xl2 lg3 md4 sm4 xs6 @click="goto('/department/list')">
            <v-card class="box-dash box-pointerdash box-success">
              <v-icon
                fab
                dark
                class="icon-menudash"
                color="success"
                style="margin-bottom: 5px"
                >fas fa-users</v-icon
              >
              <br />
              <span
                ><strong class="font-menudash">{{
                  $t("menu.DepartmentList")
                }}</strong></span
              >
            </v-card>
          </v-flex>
          <v-flex xl2 lg3 md4 sm4 xs6 @click="goto('/address/create')">
            <v-card class="box-dash box-pointerdash box-warning">
              <v-icon
                fab
                dark
                color="warning"
                class="icon-menudash"
                style="margin-bottom: 5px"
                >fas fa-map-marked-alt</v-icon
              >
              <br />
              <span
                ><strong class="font-menudash">{{
                  $t("menu.CompanyAddress")
                }}</strong></span
              >
            </v-card>
          </v-flex>
          <v-flex xl2 lg3 md4 sm4 xs6 @click="goto('/setting/general/create')">
            <v-card class="box-dash box-pointerdash box-grey">
              <v-icon
                fab
                dark
                class="icon-menudash"
                style="margin-bottom: 5px; color: #757575"
                >settings</v-icon
              >
              <br />
              <span
                ><strong class="font-menudash">{{
                  $t("menu.GeneralSetting")
                }}</strong></span
              >
            </v-card>
          </v-flex>
          <v-flex xl2 lg3 md4 sm4 xs6 @click="goto('/tax/List')">
            <v-card class="box-dash box-pointerdash box-warning">
              <v-icon
                fab
                dark
                class="icon-menudash"
                color="warning"
                style="margin-bottom: 5px"
                >fas fa-percentage</v-icon
              >
              <br />
              <span
                ><strong class="font-menudash">{{ $t("menu.TaxSetting") }}</strong></span
              >
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row justify-center>
      <v-dialog v-model="startdialog" persistent max-width="600px">
        <v-card>
          <v-stepper v-model="e1">
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card height="400px">
                  <v-layout row wrap>
                    <v-flex xs12 id="img_container">
                      <img src="../assets/call-center.png" />
                    </v-flex>
                    <v-flex xs12 text-xs-center>
                      <br />
                      <h3>
                        <strong>ยินดีต้อนรับท่าน เข้าสู่ระบบ COCO PAYDAY</strong>
                      </h3>
                      <v-btn color="primary" @click="settintHoliday()">{{
                        $t("menu.settings")
                      }}</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card height="400px">
                  <v-layout row wrap>
                    <v-flex xs12 id="img_container">
                      <img src="../assets/employee.png" />
                    </v-flex>
                    <v-flex xs12 text-xs-center>
                      <h3>
                        <strong>ท่านยังไม่ได้ลงทะเบียนให้พนักงานใช่ไหม</strong>
                      </h3>
                      <p>
                        <strong
                          >คลิกที่ปุ่ม
                          {{ $t("AddNewEmployee") }} เพื่อสร้างพนักงาน</strong
                        >
                      </p>
                      <v-btn v-if="e1 == 2" color="primary" @click="createEmployee()">{{
                        $t("AddNewEmployee")
                      }}</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
            <v-card>
              <v-layout row wrap>
                <v-flex text-xs-right></v-flex>
              </v-layout>
            </v-card>
          </v-stepper>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout row justify-center>
      <v-dialog v-model="videodialog" persistent max-width="960px">
        <v-card>
          <v-layout row wrap>
            <v-flex xs12 md8 style="min-height: 370px">
              <iframe height="100%" width="100%" :src="active_vdo"></iframe>
            </v-flex>
            <v-flex xs12 md4 style="marrgin-bottom: 20px">
              <v-list two-line>
                <v-subheader>How to</v-subheader>
                <template v-for="(item, index) in video_list">
                  <v-divider
                    v-if="item.divider"
                    :key="index"
                    :inset="item.inset"
                  ></v-divider>

                  <v-list-tile
                    v-else
                    :key="item.name"
                    avatar
                    class="box-pointerdash-vdo"
                    @click="changeVDO(index)"
                  >
                    <v-list-tile-avatar class="avoid-clicks">
                      <iframe width="60" height="60" :src="item.link"></iframe>
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="item.name"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.detail"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </v-flex>
          </v-layout>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="autoplayvideo(1)">{{
              $t("close")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import moment from "moment";
import { async } from "q";
export default {
  data: () => ({
    active_vdo: "",
    videodialog: false,
    video_list: [
      {
        link:
          "https://www.youtube.com/embed/XcqE6KzmWY4?showinfo=0&controls=0&autohide=1",
        name: "ตอนที่ 1 Training1",
        detail: "ตอนที่ 1 การใช้งานเบื้องต้น",
      },
      { divider: true, inset: true },
      // {
      //   link: "https://www.youtube.com/embed/ybfjplUp_Ls?showinfo=0&controls=0&autohide=1",
      //   name: "ตอนที่ 2 Training2",
      //   detail: "ตอนที่ 2 การใช้งานเบื้องต้น 2"
      // },
      // { divider: true, inset: true },
      // {
      //   link: "https://www.youtube.com/embed/a9WjeQX8Zaw?showinfo=0&controls=0&autohide=1",
      //   name: "ตอนที่ 3 Training3",
      //   detail: "ตอนที่ 3 การใช้งานเบื้องต้น 3"
      // },
      // { divider: true, inset: true },
      // {
      //   link: "https://www.youtube.com/embed/ybfjplUp_Ls?showinfo=0&controls=0&autohide=1",
      //   name: "ตอนที่ 4 Training4",
      //   detail: "ตอนที่ 4 การใช้งานเบื้องต้น 4"
      // },
      // { divider: true, inset: true }
    ],
    date_picker_model: {
      date: new Date().toISOString().slice(0, 10),
      toggle: false,
    },
    currentTime: null,
    formatdate: 0,
    startdialog: false,
    e1: 1,
    items: [
      { header: "How to" },
      {
        title: "Brunch this weekend?",
        subtitle:
          "<span class='text--primary'>Ali Connors</span> &mdash; I'll be in your neighborhood doing errands this weekend. Do you want to hang out?",
      },

      {
        title: 'Summer BBQ <span class="grey--text text--lighten-1">4</span>',
        subtitle:
          "<span class='text--primary'>to Alex, Scott, Jennifer</span> &mdash; Wish I could come, but I'm out of town this weekend.",
      },
      { divider: true, inset: true },
      {
        title: "Oui oui",
        subtitle:
          "<span class='text--primary'>Sandra Adams</span> &mdash; Do you have Paris recommendations? Have you ever been?",
      },
    ],
  }),
  computed: {
    ...mapState("filter", ["loading", "Employee_List"]),
    ...mapState("app", ["formatDates"]),
  },
  created: async function () {
    let v = this;
    await this.commitSetToolbar({ patternTool: "0" });
    await this.commitSetShowLoading(false);
    this.currentTime = moment().format("HH:mm:ss");
    await this.getEmployee("newData");
    this.formatdate = this.formatDates;
    // setTimeout(function () {
    //   console.log(v.Employee_List.length);
    //   if (v.Employee_List.length == 0) {
    //     v.startdialog = true;
    //   }
    // }, 5000);
    // this.active_vdo = this.video_list[0].link+'&autoplay=1';
    console.log(this.formatdate);
    setInterval(() => this.updateCurrentTime(), 1 * 1000);
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading", "getFormatDate"]),
    changeVDO(index) {
      this.active_vdo = this.video_list[index].link + "&autoplay=1";
    },
    goto(path) {
      this.$router.push(path);
    },
    dateformat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    updateCurrentTime() {
      this.currentTime = moment().format("HH:mm:ss");
    },
    onComplete() {
      this.onSaveCompanyAddress();
      this.onSaveGeneralSetting();
      this.onSaveTaxSetting();
      this.goto("dashboard");
    },

    createEmployee() {
      this.goto("employee/list");
    },
    settintHoliday() {
      this.goto("holiday/list");
    },

    autoplayvideo(act) {
      if (act == 0) {
        this.videodialog = true;
        this.active_vdo = this.video_list[0].link + "&autoplay=1";
      } else {
        this.videodialog = false;
        this.active_vdo = this.video_list[0].link + "&autohide=1";
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

h2,
span,
p {
  font-family: "Prompt", sans-serif;
}
.border {
  border: 1px black solid;
}
.scroll-area {
  position: relative;
  width: 100%;
  height: 440px;
  margin-bottom: 30px;
}
#img_container {
  width: 500px;
  display: table-cell;
  vertical-align: middle;
}
#img_container img {
  height: 150px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  display: block;
}
.background {
  background: url("../assets/banner1.png") no-repeat fixed top;
}
.box-dash {
  width: 180px !important;
  height: 180px !important;
  border-radius: 30px !important;
  background-color: #ffffff;
  box-shadow: 0 10px 6px -6px #b4b4b4;
  text-align: center;
  padding-top: 50px;
  margin: 10px;
}
.contain {
  justify-content: center;
  align-items: center;
  margin-top: 50px;
  padding-right: 10%;
  padding-left: 10%;
}
.font-menudash {
  font-size: 1rem !important;
}
.icon-menudash {
  font-size: 3rem !important;
}

/* mobile  ----------- */
@media screen and (min-width: 320px) and (max-width: 640px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
  .box-dash {
    width: 130px !important;
    height: 130px !important;
    border-radius: 20px !important;
    background-color: #ffffff;
    box-shadow: 0 10px 6px -6px #b4b4b4;
    padding-top: 35px;
    text-align: center;
  }
  .box-pointerdash {
    cursor: pointer;
    margin-bottom: 5px;
    margin-top: 5px;
  }
  .font-menudash {
    font-size: 0.7rem !important;
  }
  .icon-menudash {
    font-size: 2rem !important;
  }
}

/* tablet  ----------- */
@media screen and (max-width: 768px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
  .box-pointerdash {
    cursor: pointer;
    margin-bottom: 5px !important;
    margin-top: 5px !important;
  }
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
  .box-pointerdash {
    cursor: pointer;
    margin-bottom: 20px !important;
    margin-top: 20px !important;
  }
}

@media screen and (min-width: 1200px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: none;
  }
  .box-pointerdash {
    cursor: pointer;
    margin-bottom: 20px !important;
    margin-top: 20px !important;
  }
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
  .box-pointerdash {
    cursor: pointer;
    margin-bottom: 20px !important;
    margin-top: 20px !important;
  }
}

/* iPads pro (landscape) ----------- */
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
  .box-pointerdash {
    cursor: pointer;
    margin-bottom: 20px !important;
    margin-top: 20px !important;
  }
}

/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
  .box-pointerdash {
    cursor: pointer;
    margin-bottom: 20px !important;
    margin-top: 20px !important;
  }
}
/* .box-pointerdash {
  cursor: pointer;
  margin-bottom: 20px;
  margin-top: 20px;
} */

.box-pointerdash-vdo {
  cursor: pointer;
}
.avoid-clicks {
  pointer-events: none;
}
</style>
